import { render, staticRenderFns } from "./ViewCampaigns.vue?vue&type=template&id=08a13dbb&scoped=true"
import script from "./ViewCampaigns.vue?vue&type=script&lang=js"
export * from "./ViewCampaigns.vue?vue&type=script&lang=js"
import style0 from "./ViewCampaigns.vue?vue&type=style&index=0&id=08a13dbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a13dbb",
  null
  
)

export default component.exports